<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :modalBodyClass="$prefixClass.modal + '-notification'"
    >
        <i :class="['m-b-14 fad', modal.type == 'danger' ? 'fa-exclamation-circle' : 'fa-info-circle']"></i>
        <h4 class="m-b-12">{{modal.title}}</h4>
        <span v-if="modal.hasOwnProperty('description') || modal.description" v-html="modal.description"></span>
        <a-checkbox class="m-t-8" v-if="modal.hasOwnProperty('isChecked')"  @change="onChecked" :class="$prefixClass.checkbox + '-group'" :default-checked="modal.isChecked">
            {{modal.checkboxText}}
        </a-checkbox>
        <div class="m-t-18">
            <a-button class="m-r-8" type="secondary" @click="onCancel">{{modal.cancelText}}</a-button>
            <a-button :type="modal.type" @click="onAction">{{modal.btnText}}</a-button>
        </div>
    </vue-modal>
</template>
<script>
export default {
    name: 'ModalNotification',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    created() {
        this.modal.type = this.modal.type == undefined ? 'danger' : this.modal.type;
        this.modal.cancelText = this.modal.cancelText == undefined ? this.$t('app.buttons.cancel') : this.modal.cancelText;
    },
    methods: {
        onChecked(e) {
            if (e.target.checked) {
                this.$emit('checked-checkbox')
            }
        },
        onAction() {
            this.modal.isVisible = false
            if ( this.modal.action ) {
                this.$emit(this.modal.action)
            }
        },
        onCancel() {
            this.modal.isVisible = false
            if ( this.modal.cancelAction ) {
                this.$emit(this.modal.cancelAction)
            }
        }
    }
}
</script>
<style lang="scss">
    .m-modal-notification {
        text-align: center;
        width: 500px !important;
        .m-modal-body {
            padding: 32px 32px;
        }
        .fa-exclamation-circle {
            font-size: 48px;
            color: $warning-color;
            opacity: 0.5;
        }
        .fa-info-circle {
            font-size: 48px;
            color: $primary-color;
            opacity: 0.5;
        }
    }
</style>